import { HttpClient } from "../../../api/HttpClient"

export const loginRequest = async (identifier: string, password: string) => {
  try {
    const response = await HttpClient.post("/api/auth/local", {
      identifier,
      password,
    })
    return response
  } catch (error) {
    console.error("Error in callLogin:", error)
    throw error
  }
}

export const getRoleUser = async () => {
  try {
    const response = await HttpClient.get("/api/users/me?populate=*")
    return response.role
  } catch (error) {
    console.error("Error in getRoleUser:", error)
    throw error
  }
}

export const getPermissionUser = async ({ id }: { id: number }) => {
  try {
    const response = await HttpClient.get(`/api/users-permissions/roles/${id}`)
    return response.role.permissions
  } catch (error) {
    console.error("Error in callPermission:", error)
    throw error
  }
}
